// Sun names a field error after ITS field (`FabricationOrderFieldValidation`, the plan-type
// resolver), and two of those names are not the ficha's: the plan type travels as
// `fabricationOrderPlanTypeCode` and fails as `fabricationOrderPlanType`, and an extended column
// fails as `extendedColumnN` while the ficha keys it by its real column, `extended_columnN`.
// An error under a key no control reads is an error nobody sees.
const EXTENDED_COLUMN = /^extendedColumn(\d+)$/

export const toSheetErrorKey = (serverField) => {
  if (serverField === 'fabricationOrderPlanType') return 'planType'
  const extended = EXTENDED_COLUMN.exec(serverField || '')
  return extended ? `extended_column${extended[1]}` : (serverField || '')
}

// `unplaced` holds the messages whose field has no control on screen (e.g. `workflow`): the bar
// shows them, so a rejected save never looks like nothing happened.
export const splitFieldErrors = (serverErrors, renderedKeys) => {
  const byField = {}
  const unplaced = []
  ;(serverErrors || []).forEach((fieldError) => {
    const key = toSheetErrorKey(fieldError.field)
    if (renderedKeys.includes(key)) {
      byField[key] = fieldError.message
    } else {
      unplaced.push(fieldError.message)
    }
  })
  return { byField, unplaced }
}

// A 400 whose body lists field errors (`FabricationOrderFieldValidation`): each one belongs to a control.
export const isFieldValidationError = (error) =>
  error?.status === 400 && Array.isArray(error?.data?.errors)
